import { Chip } from '@mui/material'
import type { APIAgentPromptOrganization } from '@visorpro/client/dist/types/APIAgentPrompt'
import type { FC } from 'react'

const VISIBLE_CHIPS = 2

export const OrganizationChips: FC<{
    organizations: APIAgentPromptOrganization[]
}> = ({ organizations }) => {
    if (organizations.length === 0) {
        return <span className="color-dimmed">—</span>
    }

    const shown = organizations.slice(0, VISIBLE_CHIPS)
    const rest = organizations.length - shown.length

    return (
        <span
            data-testid="agent-prompt-orgs"
            style={{ display: 'inline-flex', gap: '0.25rem', flexWrap: 'wrap' }}
            title={organizations.map(o => o.name).join(', ')}>
            {shown.map(organization => (
                <Chip
                    key={organization.id}
                    size="small"
                    label={organization.name}
                />
            ))}
            {rest > 0 && <Chip size="small" label={`+${rest}`} />}
        </span>
    )
}

export const DefaultBadge: FC<{ isDefault: boolean }> = ({ isDefault }) => {
    if (!isDefault) return <span className="color-dimmed">—</span>
    return (
        <Chip
            size="small"
            color="success"
            label="DEFAULT"
            data-testid="agent-prompt-default"
        />
    )
}
